/** Tiny typed event emitter. */
export type Listener<T> = (payload: T) => void;

export class Emitter<EventMap extends Record<string, unknown>> {
  private map: { [K in keyof EventMap]?: Set<Listener<EventMap[K]>> } = {};

  on<K extends keyof EventMap>(type: K, fn: Listener<EventMap[K]>): () => void {
    (this.map[type] ??= new Set()).add(fn);
    return () => this.off(type, fn);
  }

  off<K extends keyof EventMap>(type: K, fn: Listener<EventMap[K]>): void {
    this.map[type]?.delete(fn);
  }

  emit<K extends keyof EventMap>(type: K, payload: EventMap[K]): void {
    this.map[type]?.forEach((fn) => fn(payload));
  }

  clear(): void {
    this.map = {};
  }
}
